import { render } from "./AppCollage.vue?vue&type=template&id=6e3b8e1c&scoped=true&ts=true"
import script from "./AppCollage.vue?vue&type=script&lang=ts"
export * from "./AppCollage.vue?vue&type=script&lang=ts"

import "./AppCollage.vue?vue&type=style&index=0&id=6e3b8e1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3b8e1c"]])

export default __exports__